import React, { useState } from "react";
import "./inventory-theme.css";

export default function AddItemModal({ isOpen, onClose, onAdd }) {
  const [form, setForm] = useState({
    name: "",
    category: "Produce",
    quantity: 0,
    unit: "kg",
    minThreshold: 0,
    expiryDate: "",
  });

  if (!isOpen) return null;

  const submit = (e) => {
    e.preventDefault();

    const payload = {
      property_code: localStorage.getItem("property_code") || "HEZEE002",
      name: form.name,
      category: form.category,
      quantity: Number(form.quantity),
      unit: form.unit,
      min_threshold: Number(form.minThreshold),
      expiry_date: form.expiryDate || null,
    };

    onAdd(payload);
    onClose();
  };

  return (
    <div className="modal fade show d-block bg-dark bg-opacity-50">
      <div className="modal-dialog modal-lg">
        <div className="modal-content soft-modal">
          <div className="soft-modal-header d-flex justify-content-between">
            <h4 className="fw-bold">✨ Add New Item</h4>
            <button className="btn btn-light rounded-circle" onClick={onClose}>
              ✕
            </button>
          </div>

          <div className="soft-modal-body">
            <form className="row g-3" onSubmit={submit}>
              {/* Item Name */}
              <div className="col-12">
                <label className="form-label fw-semibold">Item Name</label>
                <input
                  className="form-control soft-input"
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
              </div>

              {/* Category */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Category</label>
                <select
                  className="form-select soft-input"
                  value={form.category}
                  onChange={(e) =>
                    setForm({ ...form, category: e.target.value })
                  }
                >
                  <option>Produce</option>
                  <option>Dairy</option>
                  <option>Meat</option>
                  <option>Grains</option>
                </select>
              </div>

              {/* Expiry Date */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Expiry Date</label>
                <input
                  type="date"
                  className="form-control soft-input"
                  value={form.expiryDate}
                  onChange={(e) =>
                    setForm({ ...form, expiryDate: e.target.value })
                  }
                />
              </div>

              {/* Quantity */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Quantity</label>
                <input
                  type="number"
                  className="form-control soft-input"
                  value={form.quantity}
                  onChange={(e) =>
                    setForm({ ...form, quantity: e.target.value })
                  }
                />
              </div>

              {/* Unit */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Unit</label>
                <select
                  className="form-select soft-input"
                  value={form.unit}
                  onChange={(e) => setForm({ ...form, unit: e.target.value })}
                >
                  <option>kg</option>
                  <option>g</option>
                  <option>L</option>
                  <option>pcs</option>
                </select>
              </div>

              {/* Low Stock */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Low Stock Threshold
                </label>
                <input
                  type="number"
                  className="form-control soft-input"
                  value={form.minThreshold}
                  onChange={(e) =>
                    setForm({ ...form, minThreshold: e.target.value })
                  }
                />
              </div>
            </form>
          </div>

          <div className="soft-modal-footer d-flex justify-content-between">
            <button className="btn btn-light px-4" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-soft-primary px-4" onClick={submit}>
              Save Item
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
